import { uploadBlobToS3 } from './imageUploadService';
import { BASE_URL } from '../settings';

// Agent image-enhance lives inside the main backend (searchservice).
// Default: `${BASE_URL}search/agent` → /api/search/agent via the API gateway.
const AGENT_API_URL = process.env.REACT_APP_AGENT_URL || `${BASE_URL}search/agent`;

/**
 * Fetches a remote image URL and returns a File for the enhance API.
 */
export async function fetchImageAsFile(imageUrl, fileName = 'space-image.jpg') {
  const response = await fetch(imageUrl);
  if (!response.ok) {
    throw new Error('Could not load the image. Please try again.');
  }
  const blob = await response.blob();
  const extension = blob.type === 'image/png' ? 'png' : 'jpg';
  const baseName = fileName.replace(/\.[^.]+$/, '') || 'space-image';
  return new File([blob], `${baseName}.${extension}`, { type: blob.type || 'image/jpeg' });
}

/**
 * Sends an image file to the agent enhance endpoint; returns the enhanced PNG blob.
 */
export async function enhanceImageFile(file) {
  const formData = new FormData();
  formData.append('image', file);

  const response = await fetch(`${AGENT_API_URL}/image/enhance`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.error || `Enhancement failed (${response.status})`);
  }

  return response.blob();
}

/**
 * Uploads a blob to S3 using the new presigned URL flow.
 * Returns an object with the public URL to replace the old Cloudinary response.
 */
export async function uploadEnhancedImageToS3(blob, fileName = 'enhanced.png', imageSpace, referenceId) {
  return uploadBlobToS3(blob, fileName, imageSpace, referenceId, { compress: false });
}
